import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import AboutPage from '../pages/about/page';
import LocationPage from '../pages/location/page';
import AntiquesPage from '../pages/collections/antiques/page';
import FurniturePage from '../pages/collections/furniture/page';
import GiftsPage from '../pages/collections/gifts/page';
import ApparelPage from '../pages/collections/apparel/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/about', element: <AboutPage /> },
  { path: '/location', element: <LocationPage /> },
  { path: '/collections/antiques', element: <AntiquesPage /> },
  { path: '/collections/furniture', element: <FurniturePage /> },
  { path: '/collections/gifts', element: <GiftsPage /> },
  { path: '/collections/apparel', element: <ApparelPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
